import type { TutorialPageDef } from '../types';

export const workspaceTutorials: TutorialPageDef[] = [
  {
    key: 'taap',
    label: '広告運用ダッシュボード',
    paths: ['/taap'],
    steps: [
      {
        target: 'taap-tabs',
        title: '広告運用の3画面',
        body: 'ダッシュボード・提案・連携設定をタブで切り替えられます。',
      },
      {
        target: 'taap-kpi',
        title: '主要指標を一目で確認',
        body: '費用・CV・CPAなど、広告の実績をまとめて確認できます。',
      },
      {
        target: 'taap-chart',
        title: '実績の推移グラフ',
        body: '指標と集計期間を切り替えて、日々の変化を確認できます。',
      },
      {
        target: 'taap-proposals',
        title: '今すぐ効く改善提案',
        body: '毎朝の自動診断で見つかった改善案をここで確認できます。',
      },
    ],
  },
  {
    key: 'taap-proposals',
    label: '提案・承認',
    paths: ['/taap/proposals'],
    steps: [
      {
        target: 'taap-proposals-tabs',
        title: '提案・承認画面',
        body: 'ダッシュボードや連携設定とタブで切り替えられます。',
      },
      {
        target: 'taap-proposals-filter',
        title: '状態で絞り込み',
        body: '未承認・実行済み・却下で提案を絞り込めます。',
      },
      {
        target: 'taap-proposals-list',
        title: '提案の一覧',
        body: '各提案を開くと、根拠データと承認・却下の操作を確認できます。',
      },
    ],
  },
  {
    key: 'taap-proposal-detail',
    label: '改善提案（詳細）',
    paths: ['/taap/proposals/:proposalId'],
    steps: [
      {
        target: 'taap-proposal-detail-summary',
        title: '提案の詳細',
        body: '対象・優先度・推定効果を確認し、承認または却下できます。',
      },
    ],
  },
  {
    key: 'ad-dashboard',
    label: '媒体広告ダッシュボード',
    paths: ['/ad-dashboard/meta', '/ad-dashboard/google'],
    steps: [
      {
        target: 'ad-dashboard-tabs',
        title: '媒体ダッシュボード',
        body: 'Meta・Google広告のタブで表示を切り替えられます。',
      },
      {
        target: 'ad-dashboard-filter',
        title: '期間・アカウントを指定',
        body: '集計期間や広告アカウントを選んで表示を絞り込めます。',
      },
      {
        target: 'ad-dashboard-kpi',
        title: '主要指標のサマリー',
        body: '表示回数・クリック・コンバージョンなどをまとめて確認できます。',
      },
      {
        target: 'ad-dashboard-table',
        title: '明細データを確認',
        body: 'キャンペーンや広告単位の実績を詳しく確認できます。',
      },
    ],
  },
  {
    key: 'media-connect',
    label: '媒体連携設定',
    paths: ['/settings/media-connect'],
    steps: [
      {
        target: 'media-connect-tabs',
        title: '媒体連携設定画面',
        body: 'ダッシュボードや提案画面とタブで切り替えられます。',
      },
      {
        target: 'media-connect-google',
        title: 'Google広告連携',
        body: 'Google広告アカウントの連携状態をここで確認・設定できます。',
      },
      {
        target: 'media-connect-meta',
        title: 'Meta広告連携',
        body: 'Meta広告アカウントの連携状態をここで確認・設定できます。',
      },
    ],
  },
  {
    key: 'document-v3',
    label: 'AI資料3',
    paths: ['/document-v3'],
    steps: [
      {
        target: 'document-v3-create',
        title: '新規プロジェクト作成',
        body: 'ボタンから新しいAI資料のプロジェクトを作成できます。',
      },
      {
        target: 'document-v3-list',
        title: '作成済み資料の一覧',
        body: 'カードを選ぶとエディタが開き、続きを編集できます。',
      },
    ],
  },
  {
    key: 'document-v3-editor',
    label: 'AI資料3（編集）',
    paths: ['/document-v3/:projectId'],
    steps: [
      {
        target: 'document-v3-editor-back',
        title: '一覧へ戻る',
        body: 'このボタンでプロジェクト一覧に戻れます。',
      },
      {
        target: 'document-v3-editor-steps',
        title: '構成からデザインまで',
        body: '①構成→②ページ→③デザイン→④書き出しの順にタブで進められます。',
      },
      {
        target: 'document-v3-editor-content',
        title: 'ステップの編集画面',
        body: '選んだステップの内容がここに表示され、その場で編集できます。',
      },
    ],
  },
  {
    key: 'video-document',
    label: 'AI動画資料',
    paths: ['/video-document'],
    steps: [
      {
        target: 'document-v3-create',
        title: '新規プロジェクト作成',
        body: 'ボタンから新しいAI動画資料のプロジェクトを作成できます。',
      },
      {
        target: 'document-v3-list',
        title: '作成済み動画資料の一覧',
        body: 'カードを選ぶとエディタが開き、続きを編集できます。',
      },
    ],
  },
  {
    key: 'video-document-editor',
    label: 'AI動画資料（編集）',
    paths: ['/video-document/:projectId'],
    steps: [
      {
        target: 'document-v3-editor-back',
        title: '一覧へ戻る',
        body: 'このボタンでプロジェクト一覧に戻れます。',
      },
      {
        target: 'document-v3-editor-steps',
        title: 'ナレーションと動画も作成',
        body: '①構成〜③デザインに続き、④ナレーション⑤動画をタブで進められます。',
      },
      {
        target: 'document-v3-editor-content',
        title: 'ステップの編集画面',
        body: '選んだステップの内容がここに表示され、その場で編集できます。',
      },
    ],
  },
  {
    key: 'organization',
    label: '組織情報',
    paths: ['/organization', '/organization/members', '/organization/settings', '/organization/analytics'],
    steps: [
      {
        target: 'organization-score',
        title: 'AI活用スコア',
        body: '組織全体とあなた自身のAI活用スコアを確認できます。',
      },
      {
        target: 'organization-invite',
        title: 'メンバーを招待',
        body: 'メールアドレスを入力して新しいメンバーを招待できます。',
      },
      {
        target: 'organization-members',
        title: 'メンバー一覧',
        body: '所属メンバーと招待中のメンバーを確認できます。',
      },
    ],
  },
  {
    key: 'organization-edit',
    label: '組織管理',
    paths: ['/organization/edit'],
    steps: [
      {
        target: 'organization-edit-info',
        title: '組織情報の編集',
        body: '組織名やメンバー数、クレジット残高を確認・編集できます。',
      },
      {
        target: 'organization-edit-invite-code',
        title: '招待コードの設定',
        body: '招待コードと付与クレジットを設定できます。',
      },
      {
        target: 'organization-edit-members',
        title: 'メンバーの管理',
        body: 'メンバーの追加・権限変更・削除をここで行えます。',
      },
      {
        target: 'organization-edit-danger',
        title: 'アカウントの削除',
        body: '組織全体を削除する操作です。取り消せないため注意してください。',
      },
    ],
  },
  {
    key: 'account-settings',
    label: 'アカウント設定',
    paths: ['/account/settings'],
    steps: [
      {
        target: 'account-settings-profile',
        title: '基本情報の確認',
        body: '名前・メールアドレス・ロールなどの基本情報を確認できます。',
      },
      {
        target: 'account-settings-login-method',
        title: 'ログイン方法の管理',
        body: 'パスワードやGoogleログインの設定をここで変更できます。',
      },
      {
        target: 'account-settings-mcp-token',
        title: 'MCPアクセストークン',
        body: 'Claude CodeなどからTaskyを操作するトークンを発行できます。',
      },
      {
        target: 'account-settings-billing',
        title: '支払い・プラン変更',
        body: 'サブスクの変更やお支払い内容の確認ができます。',
      },
    ],
  },
  {
    key: 'usage',
    label: '利用状況',
    paths: ['/usage'],
    steps: [
      {
        target: 'usage-period',
        title: '集計期間を切り替え',
        body: '24時間・1週間・1ヶ月・1年で表示を切り替えられます。',
      },
      {
        target: 'usage-summary',
        title: '利用状況のサマリー',
        body: '総クレジットや画像生成数などをまとめて確認できます。',
      },
      {
        target: 'usage-features',
        title: '機能別の使用量',
        body: 'チャットや画像生成など、機能ごとの使用量を確認できます。',
      },
      {
        target: 'usage-daily-chart',
        title: '日別の使用量グラフ',
        body: '日ごとの利用量の変化をグラフで確認できます。',
      },
    ],
  },
  {
    key: 'profile',
    label: 'プロフィール設定',
    paths: ['/profile'],
    steps: [
      {
        target: 'profile-account',
        title: 'アカウント情報',
        body: '名前やメールアドレスを確認・編集できます。',
      },
      {
        target: 'profile-subscription',
        title: 'サブスクリプション',
        body: '現在のプランを確認し、変更もできます。',
      },
      {
        target: 'profile-usage-stats',
        title: '使用統計',
        body: 'メッセージ数や会話数などの使用状況を確認できます。',
      },
    ],
  },
  {
    key: 'ai-score',
    label: 'AI活用スコア',
    paths: ['/ai-score'],
    steps: [
      {
        target: 'ai-score-date-filter',
        title: '集計期間を選択',
        body: '今月・今週・今日・カスタムの範囲で絞り込めます。',
      },
      {
        target: 'ai-score-csv',
        title: 'CSVで書き出し',
        body: '表示中のデータをCSVファイルでダウンロードできます。',
      },
      {
        target: 'ai-score-members',
        title: 'メンバー別の活用状況',
        body: 'メンバーごとのAI活用スコアとよく使うエージェントを確認できます。',
      },
    ],
  },
  {
    key: 'agents',
    label: 'エージェント一覧',
    paths: ['/agents'],
    steps: [
      {
        target: 'agents-create',
        title: 'エージェントを作成',
        body: '組織専用のオリジナルAIエージェントを作成できます。',
      },
      {
        target: 'agents-search-sort',
        title: '検索と並び替え',
        body: 'キーワード検索や、お気に入り・使用頻度での並び替えができます。',
      },
      {
        target: 'agents-categories',
        title: 'カテゴリで絞り込み',
        body: 'カテゴリを選ぶと、そのジャンルのエージェントだけ表示されます。',
      },
      {
        target: 'agents-grid',
        title: 'エージェント一覧',
        body: 'カードを選ぶとチャットを開始できます。',
      },
    ],
  },
];
